import { ArrayField } from 'react-hook-form';

import { DosageStageUnion, DosageStageValidation } from '~libs.shared.prescription';

import { ExtendedDosageFormController } from '../ExtendedDosageForm.types';
import { DosageCycleClass } from '../../extendedDosage.utils';

import { StageFieldBody } from './StageFieldBody';
import { StageFieldNotifications } from './StageFieldNotifications';
import { StageHeader } from './StageHeader';
import { StageModeRadioGroup } from './StageModeRadioGroup';
import { StyledStageField } from './StageField.styled';

type StageFieldProps = Pick<ExtendedDosageFormController, 'register' | 'watch' | 'setValue' | 'trigger'> & {
   readonly field: Partial<ArrayField<DosageStageUnion>>;
   readonly index: number;
   readonly validation: DosageStageValidation;
   readonly ordinalNumber: number;
   readonly days: number;
   readonly duplicable: boolean;
   readonly portionUnit: string | null;
   readonly onRemove: (index: number) => void;
   readonly onDuplicate: (index: number) => void;
   readonly onChangeStageMode: (index: number, mode: DosageCycleClass) => void;
};

export const StageField = (props: StageFieldProps): JSX.Element => {
   const isBreak = props.field.class === 'DosageBreak';
   const isCycle = !isBreak;
   const isTimesOfDay = props.field.class === 'TimesOfDayDosageCycle';
   const mode: DosageCycleClass = isTimesOfDay ? 'TimesOfDayDosageCycle' : 'FrequencyDosageCycle';

   return (
      <StyledStageField>
         <StageHeader
            index={props.index}
            isBreak={isBreak}
            ordinalNumber={props.ordinalNumber}
            days={props.days}
            duplicable={props.duplicable}
            onDuplicate={props.onDuplicate}
            onRemove={props.onRemove}
         />
         {isCycle ? (
            <StageModeRadioGroup index={props.index} mode={mode} onChangeStageMode={props.onChangeStageMode} />
         ) : null}
         <StageFieldBody
            register={props.register}
            watch={props.watch}
            setValue={props.setValue}
            trigger={props.trigger}
            field={props.field}
            index={props.index}
            validation={props.validation}
            portionUnit={props.portionUnit}
         />
         <StageFieldNotifications index={props.index} validation={props.validation} />
      </StyledStageField>
   );
};
